(function($){
    $(function(){
        var $hero = $('#zn-hero'),
            $slick = $hero.find('.zn-hero-slick');

        if ($hero.length){
            $slick.parallax({speed: 2});

            $hero.find('.zn-site-width').parallax({speed: 3});

            $slick.slick({
                autoplay: true,
                arrows: false,
                fade: true,
                pauseOnHover: false,
                touchMove: false,
                autoplaySpeed: 7000,
                speed: 1000
            });
        }
    });  
})($JQ);